import BaseMapPopup from 'components/BaseMap/components/BaseMapPopup';
import WeatherWidgetDetails from 'features/Weather/components/WeatherWidgetDetails/WeatherWidgetDetails';
import { Popup, useMap } from 'react-leaflet';
import { joinClasses } from 'utils/componentStyles/style.utils';
import '../../assets/weatherMaps.scss';

const WeatherMapDetailsPopup = ({
  eyebrow,
  title,
  subtitle,
  status,
  statusClassName,
  meta,
  selectedItem,
  details,
  layoutGroups,
  detailsClassName,
  ariaLabel,
  children,
}) => {
  const map = useMap();

  return (
    <Popup className="base-map-popup-leaflet" closeButton={false}>
      <BaseMapPopup
        eyebrow={eyebrow}
        title={title}
        subtitle={subtitle}
        status={status}
        statusClassName={statusClassName}
        meta={meta}
        density="compact"
        onClose={() => map.closePopup()}
      >
        <WeatherWidgetDetails
          selectedItem={selectedItem}
          details={details}
          layoutGroups={layoutGroups}
          containerClassName={joinClasses('weather-map-detail-grid', detailsClassName)}
          iconSize={14}
          ariaLabel={ariaLabel}
        />
        {children}
      </BaseMapPopup>
    </Popup>
  );
};

export default WeatherMapDetailsPopup;
